module.exports = __webpack_public_path__ + "img/plane-ssj100.084d4657.svg";